<template>
  <div class="table-page" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="cnt-header">
      <div class="top-btn">
        <el-button-group>
          <el-button type="primary" @click="addCustomersBtn">添加客户</el-button>
        </el-button-group>
      </div>
      <div class="search-input">
        <el-input
          style="width: 435px"
          :clearable="true"
          placeholder="输入(会议名称/企业名称/税号/地址/电话/开户行)检索"
          class="input-with-select"
          v-model="query"
          @keyup.enter.native="startQuery"
          @clear="clearInputVal"
        >
          <el-button slot="append" icon="el-icon-search" @click="startQuery"></el-button>
        </el-input>
        <el-button-group style="margin-left: 55px">
          <el-button
            type="primary"
            @click="uploaderBtn"
            round
            size="small"
            icon="el-icon-upload2"
            >导入</el-button
          >
          <el-button
            type="primary"
            round
            size="small"
            icon="el-icon-download"
            @click="filesExport('customers')"
            >导出</el-button
          >
        </el-button-group>
      </div>
    </div>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="meet_name" label="会议名称"> </el-table-column>
      <el-table-column prop="company_name" label="企业名称"> </el-table-column>
      <el-table-column prop="tax_num" label="税号"> </el-table-column>
      <el-table-column prop="address" label="地址"> </el-table-column>
      <el-table-column prop="phone" label="电话"> </el-table-column>
      <el-table-column prop="bank" label="开户行"> </el-table-column>
      <el-table-column prop="bank_account" label="开户行账号"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="240">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="updateCustomersBtn(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="small"
            style="color: #f56c6c"
            @click="delCustomers(scope.row.customer_id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 25px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="form.customer_id == null ? '新建客户' : '修改客户'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <div style="margin: 0 15px 0 35px">
        <el-form ref="form" :model="form" label-width="130px" :rules="rules">
          <div class="form-item-line">
            <el-form-item label="会议名称" prop="meet_name" class="left">
              <el-input v-model="form.meet_name"></el-input>
            </el-form-item>
            <el-form-item label="单位名称" prop="company_name" class="left">
              <el-input v-model="form.company_name"></el-input>
            </el-form-item>
          </div>

          <div class="form-item-line">
            <el-form-item label="税号" prop="tax_num" class="left">
              <el-input v-model="form.tax_num"></el-input>
            </el-form-item>
            <el-form-item label="地址" prop="address" class="left">
              <el-input v-model="form.address"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="phone" class="left">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>
          </div>

          <div class="form-item-line">
            <el-form-item label="开户行" prop="bank" class="left">
              <el-input v-model="form.bank"></el-input>
            </el-form-item>
            <el-form-item label="开户行账号" prop="bank_account" class="left">
              <el-input v-model="form.bank_account"></el-input>
            </el-form-item>
          </div>

          <div class="form-item-line">
            <el-form-item label="负责人" prop="principal" class="left">
              <el-input v-model="form.principal"></el-input>
            </el-form-item>
            <el-form-item label="负责人电话" prop="principal_call" class="left">
              <el-input v-model="form.principal_call"></el-input>
            </el-form-item>
          </div>

          <div class="form-item-line">
            <el-form-item label="备注" prop="remark" class="left">
              <el-input v-model="form.remark" type="textarea"></el-input>
            </el-form-item>
          </div>

          <el-form-item>
            <el-button
              type="primary"
              @click="createCustomers"
              v-if="form.customer_id == null"
              >立即创建</el-button
            >
            <el-button type="primary" @click="updateCustomers" v-else>立即修改</el-button>
            <el-button @click="dialogFormVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- 文件上传表单 -->
    <el-dialog
      element-loading-text="Loading"
      element-loading-spinner="el-icon-loading"
      title="导入客户信息"
      :visible.sync="dialogFileFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-upload
          class="upload-demo"
          ref="upload"
          :action="host + '/api/customers/uploader'"
          :http-request="uploadFiles"
          name="fname"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="1"
          :auto-upload="false"
          :on-exceed="handleExceed"
          :file-list="fileList"
          :on-change="handleChange"
          :data="uploadArgs"
          :on-success="handleSuccess"
        >
          <el-button size="small" type="primary" :disabled="fileLength > 0"
            >上传文件</el-button
          >
        </el-upload>
        <ul class="custom-dic-explanation">
          <li>文件扩展名要为xlsx或xls, 不超过10MB，编码仅支持UTF-8</li>
          <span class="custom-dic-template-download"
            ><a href="/files/文件导入模板.7z" class="custom-dic-demo-link"
              >参考demo下载</a
            ></span
          >
        </ul>
        <el-checkbox v-model="uploadArgs.is_cover" style="margin-top: 25px"
          >覆盖导入</el-checkbox
        >
        <font class="custom-dic-config"> （当前客户信息中的值将被清空） </font>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose('cancel')">取 消</el-button>
        <el-button
          type="primary"
          @click="handleDialogClose('confirm')"
          :disabled="fileLength <= 0"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fullscreenLoading: false,
      serviceTypeOpts: [],
      uploadArgs: {
        is_cover: false,
      },
      fileLength: 0,
      fileList: [],
      dialogFileFormVisible: false,
      form: {
        customer_id: null,
        meet_name: "",
        company_name: "",
        tax_num: "",
        address: "",
        phone: "",
        bank: "",
        bank_account: "",
        principal: "",
        principal_call: "",
        remark: "",
      },
      options: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      userInfo: {
        is_admin: false,
        user_id: null,
        username: "",
      },
      dialogFormVisible: false,
      rules: {
        meet_name: [{ required: true, message: "请输入会议名称", trigger: "blur" }],
      },
      query: null,
    };
  },
  methods: {
    startQuery() {
      let that = this;
      that.currentPage = 1;
      if (that.query) {
        if (!that.query.trim()) {
          that.query = null;
        }
      }
      that.loadCustomers(that.currentPage, that.pageSize);
    },
    clearInputVal() {
      let that = this;
      that.loadCustomers(that.currentPage, that.pageSize);
    },
    filesExport(fileType) {
      let that = this;
      that.fullscreenLoading = true;
      that.$axios
        .get(that.host + "/api/files/exporter?file_type=" + fileType, {
          responseType: "blob",
          headers: { "Cache-Control": "no-cache" },
        })
        .then((res) => {
          let blob = new Blob([res.data]);
          let link = document.createElement("a");
          link.download = fileType + ".xlsx";
          link.href = URL.createObjectURL(blob);
          link.click();
          URL.revokeObjectURL(link.href);
          that.fullscreenLoading = false;
        })
        .catch((err) => {
          let resData = err.data;
          if(err.data.type == "application/json"){
            const fileReader = new FileReader();
            fileReader.onloadend = () => {
              let jsonData = JSON.parse(fileReader.result)
              // 后台信息
              that.$message.error(jsonData.errmsg);
              that.fullscreenLoading = false;
            }
            fileReader.readAsText(resData);
          }
        });
    },
    handleRemove(file, fileList) {
      let that = this;
      that.fileLength = 0;
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    handleChange(file, fileList) {
      let that = this;
      if (!file.name.endsWith("xlsx") && !file.name.endsWith("xls")) {
        that.$message.error("文件格式有误！");
        that.$refs.upload.clearFiles();
        that.fileLength = 0;
        that.uploadArgs.is_cover = false;
        return;
      }
      if (file.size / 1024 / 1024 > 10) {
        that.$message.error("文件大小超过10M有误！");
        that.$refs.upload.clearFiles();
        that.fileLength = 0;
        that.uploadArgs.is_cover = false;
        return;
      }
      that.fileLength = fileList.length;
    },
    uploadFiles(params) {
      let that = this;
      let fileObj = params.file;
      let action = params.action;
      let form = new FormData();
      that.fullscreenLoading = true;
      // 文件对象
      form.append("fname", fileObj);
      form.append("is_cover", that.uploadArgs.is_cover);
      that.$axios
        .post(action, form, { headers: { "Content-Type": "multipart/form-data" } })
        .then((res) => {
          that.handleSuccess(res.data);
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
          that.fullscreenLoading = false;
        });
    },
    handleSuccess(res, file, fileList) {
      let that = this;
      that.$refs.upload.clearFiles();
      that.dialogFileFormVisible = false;
      that.fileLength = 0;
      that.uploadArgs.is_cover = false;
      that.loadCustomers(that.currentPage, that.pageSize);
      that.fullscreenLoading = false;
      that.$message.success("导入成功");
    },
    handleDialogClose(action) {
      let that = this;
      if (action == "cancel") {
        // 处理取消弹出框
        if (that.fileLength > 0) {
          that
            .$confirm("文件尚未上传，确认关闭？")
            .then((_) => {
              that.$refs.upload.clearFiles();
              that.dialogFileFormVisible = false;
              that.fileLength = 0;
              that.uploadArgs.is_cover = false;
            })
            .catch((_) => {});
        } else {
          that.dialogFileFormVisible = false;
          that.uploadArgs.is_cover = false;
        }
      } else if (action == "confirm") {
        // 处理确认弹出框
        that.loading = true;
        that.$refs.upload.submit();
        // that.dialogFormVisible = false;
      } else {
        that.$message.error("未知的动作！");
      }
    },
    uploaderBtn() {
      let that = this;
      that.dialogFileFormVisible = true;
    },
    handleSizeChange(pageSize) {
      let that = this;
      that.pageSize = pageSize;
      that.loadCustomers(that.currentPage, pageSize);
    },
    handleCurrentChange(currentPage) {
      let that = this;
      that.currentPage = currentPage;
      that.loadCustomers(that.currentPage, that.pageSize);
    },
    updateCustomers() {
      let that = this;
      that.$axios
        .put(that.host + "/api/customers", that.form)
        .then((res) => {
          that.$message.success("修改成功");
          that.dialogFormVisible = false;
          that.loadCustomers(that.currentPage, that.pageSize);
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
    updateCustomersBtn(data) {
      let that = this;
      that.form = data;
      that.dialogFormVisible = true;
    },
    delCustomers(customerID) {
      let that = this;
      this.$confirm("此操作将永久删除该客户信息, 是否继续?", "删除供应商", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          that.$axios
            .delete(that.host + "/api/customers", {
              data: { customer_id: customerID },
            })
            .then((res) => {
              that.$message.success("删除客户信息成功");
              that.currentPage = 1;
              that.loadCustomers(that.currentPage, that.pageSize);
            })
            .catch((err) => {
              that.$message.error(err.data.errmsg);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    addCustomersBtn() {
      let that = this;
      that.dialogFormVisible = true;
      that.form = {
        customer_id: null,
        meet_name: "",
        company_name: "",
        tax_num: "",
        address: "",
        phone: "",
        bank: "",
        bank_account: "",
        principal: "",
        principal_call: "",
        remark: "",
      };
    },
    loadCustomers(page, pageSize) {
      let that = this;
      let reqUrl = that.host + "/api/customers?page=" + page + "&page_size=" + pageSize;
      if (that.query) {
        reqUrl += "&query=" + that.query;
      }
      that.$axios
        .get(reqUrl)
        .then((res) => {
          let results = res.data.results;
          that.tableData = results.customers;
          that.total = results.total_count;
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
    createCustomers() {
      let that = this;
      that.$refs["form"].validate((valid) => {
        if (valid) {
          that.$axios
            .post(that.host + "/api/customers", that.form)
            .then((res) => {
              that.$message.success("创建成功");
              that.dialogFormVisible = false;
              that.loadCustomers(that.currentPage, that.pageSize);
            })
            .catch((err) => {
              that.$message.error(err.data.errmsg);
            });
        } else {
          that.$message.warning("参数验证失败");
          return false;
        }
      });
    },
  },
  mounted() {
    let that = this;
    that.loadCustomers(that.currentPage, that.pageSize);
  },
};
</script>

<style>
.filter-label {
  font-size: 14px;
  color: #e6a23c;
}
.cnt-header {
  position: relative;
  margin-bottom: 25px;
  line-height: 34px;
}
.filter-top {
  margin-right: 25px;
  display: inline-block;
}
.cnt-header .top-btn {
  display: inline-block;
}
.cnt-header .search-input {
  float: right;
}
.form-item-line {
  display: inline-block;
}
.form-item-line .left {
  float: left;
}
.table-page {
  padding: 0 30px 0 30px;
}
</style>
